import AplicacaoPadrao from "esocial.web.react.lib/cjs/components/AplicacaoPadrao";
import { Route } from "react-router";
import Home from './pages/Home';
import { ThemeProvider } from '@mui/material';
import theme from "./common/theme";
import RelatoriosGerenciaisListagem from './pages/RelatoriosGerenciais/RelatoriosGerenciaisListagem';
import RelatoriosGerenciaisRegistro from './pages/RelatoriosGerenciais/RelatoriosGerenciaisRegistro';
import RelatoriosGerenciaisValidacao from './pages/RelatoriosGerenciais/RelatoriosGerenciaisValidacao';
import { RelatoriosGerenciaisProvider } from './contexts/RelatoriosGerenciaisContext';

function App() {
    const rotasPublicas = [
        {
            path: "validacao", modulo: 'Relatórios Gerenciais',
            element:
                <ThemeProvider theme={theme}>
                    <RelatoriosGerenciaisValidacao />
                </ThemeProvider>
        },
    ];

    return (
        <RelatoriosGerenciaisProvider>
            <AplicacaoPadrao publicRoutes={rotasPublicas}>
                <Route index element={<Home />} />
                <Route path="gerenciamento">
                    <Route index
                        element={
                            <ThemeProvider theme={theme}>
                                <RelatoriosGerenciaisListagem />
                            </ThemeProvider>
                        }
                    />
                    <Route path="registro"
                        element={
                            <ThemeProvider theme={theme}>
                                <RelatoriosGerenciaisRegistro />
                            </ThemeProvider>
                        }
                    />
                </Route>
            </AplicacaoPadrao>

        </RelatoriosGerenciaisProvider>
    );
}

export default App;
